/* eslint-disable prettier/prettier */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable no-unused-vars */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import GetApp from '@material-ui/icons/GetApp';
import {
  TablePagination,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { formatCurrency } from '../../../../service/utils';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function BalanceTable({
  docs,
  page,
  setPage,
  itens,
  setItens,
  total,
  getXls,
}) {
  const classes = useStyles();
  const history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(event.target.value, 10);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>NF/ND</StyledTableCell>
              <StyledTableCell>CNPJ</StyledTableCell>
              <StyledTableCell>CLIENTE</StyledTableCell>
              <StyledTableCell>PEDIDO</StyledTableCell>
              <StyledTableCell>N° PEDIDO</StyledTableCell>
              <StyledTableCell>PROVISÃO</StyledTableCell>
              <StyledTableCell>CONSUMIDO</StyledTableCell>
              <StyledTableCell>SALDO RESTANTE</StyledTableCell>
              <StyledTableCell>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  DATA PEDIDO
                  <GetApp onClick={getXls} style={{ cursor: 'pointer' }} />
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(row => {
              const provision = Number(row.provision || 0);
              const consumed = Number(row.consumed || 0);
              const balance = provision - consumed;

              return (
                <StyledTableRow key={row.id}>
                  <StyledTableCell>{row.document_number || '-'}</StyledTableCell>
                  <StyledTableCell>{row.client_cnpj || '-'}</StyledTableCell>
                  <StyledTableCell>{row.client_name || '-'}</StyledTableCell>
                  <StyledTableCell>{row.order_name || '-'}</StyledTableCell>
                  <StyledTableCell
                    style={{ cursor: 'pointer', color: 'blue' }}
                    onClick={() => history.push(`orderDetails/${row.id}`)}
                  >
                    {row.order_number || '-'}
                  </StyledTableCell>
                  <StyledTableCell>{formatCurrency(provision)}</StyledTableCell>
                  <StyledTableCell>{formatCurrency(consumed)}</StyledTableCell>
                  <StyledTableCell>{formatCurrency(balance)}</StyledTableCell>
                  <StyledTableCell>
                    {row.created_at
                      ? moment(row.created_at).format('DD/MM/YYYY')
                      : '-'}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100, 1000, 50000]}
        component="div"
        count={total}
        rowsPerPage={itens}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
